// Usuarios
//
import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from '../../services/api'
import PrivatePageSection from '../../components/layout/PrivatePageSection'
import { pickValue, toSafeText } from '../../utils/defensiveData'
import {
  Alert,
  Box,
  Container,
  Typography,
  CircularProgress,
  Grid,
  Card,
  CardContent,
  CardActionArea,
  Divider,
  Stack,
  Chip,
  Paper,
} from '@mui/material'

const Users = () => {
  const navigate = useNavigate()
  const [users, setUsers] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get('/users')
        const payload = response?.data
        const list = Array.isArray(payload)
          ? payload
          : Array.isArray(payload?.users)
          ? payload.users
          : []
        setUsers(list)
      } catch (error) {
        console.error('Error fetching users:', error)
        setUsers([])
      } finally {
        setLoading(false)
      }
    }

    fetchUsers()
  }, [])

  if (loading) {
    return (
      <Container sx={{ textAlign: 'center', py: 5 }}>
        <CircularProgress />
      </Container>
    )
  }

  return (
    <PrivatePageSection
      title="Usuarios"
      subtitle="Catálogo operativo de cuentas internas. Selecciona una tarjeta para abrir la ficha de detalle."
    >
      <Grid container spacing={3}>
        {users.length > 0 ? (
          users.map((user) => {
            const userId = pickValue(user, 'id', 'id', null)
            const hasValidId =
              userId !== null &&
              userId !== undefined &&
              String(userId).trim() !== ''

            const names = toSafeText(pickValue(user, 'names', 'names', ''), '')
            const lastNameF = toSafeText(
              pickValue(user, 'lastname_f', 'lastNameP', ''),
              ''
            )
            const lastNameM = toSafeText(
              pickValue(user, 'lastname_m', 'lastNameM', ''),
              ''
            )
            const fullName = `${names} ${lastNameF} ${lastNameM}`.trim() || 'Sin nombre'
            const email = toSafeText(pickValue(user, 'email', 'email', '-'), '-')
            const clientId = toSafeText(
              pickValue(user, 'client_id', 'clientId', 'N/A'),
              'N/A'
            )

            return (
              <Grid item xs={12} sm={6} md={4} lg={3} key={user.id || fullName}>
                <Card variant="outlined" sx={{ minHeight: 170, height: '100%' }}>
                  <CardActionArea
                    disabled={!hasValidId}
                    onClick={() => navigate(`/users/${userId}`, { state: { user } })}
                    sx={{ height: '100%' }}
                  >
                    <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                      <Box>
                        <Typography variant="h6" sx={{ fontWeight: 700 }}>
                          {fullName}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          ID: {toSafeText(userId, '—')}
                        </Typography>
                      </Box>

                      <Stack direction="row" spacing={1} useFlexGap sx={{ flexWrap: 'wrap' }}>
                        <Chip size="small" variant="outlined" label={`Cliente: ${clientId}`} />
                      </Stack>

                      <Divider />

                      <Typography color="text.secondary">{email}</Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            )
          })
        ) : (
          <Grid item xs={12}>
            <Paper variant="outlined" sx={{ p: 3, borderRadius: 2.5 }}>
              <Stack spacing={1}>
                <Alert severity="info">No hay usuarios registrados.</Alert>
                <Typography variant="body2" color="text.secondary">
                  Cuando existan cuentas internas activas, aparecerán aquí para navegar a su detalle.
                </Typography>
              </Stack>
            </Paper>
          </Grid>
        )}
      </Grid>
    </PrivatePageSection>
  )
}

export default Users
